export function isNetworkSwitchEnabled(env = process.env) {
  const configured = env.REACT_APP_NETWORK_SWITCH;
  return configured == null || configured === ''
    ? env.REACT_APP_SUBSCRIPTIONS === 'enabled'
    : ['true', 'enabled', '1'].includes(configured);
}

export function selectNetwork(network, storage = localStorage) {
  // Only authentication and personal display preferences survive a context switch.
  const keep = new Set(['userToken', 'refreshToken', 'refreshTokenExpiration',
    'refresh_token_expiration', 'userId', 'userName', 'userRealName', 'userEmail',
    'trackieLanguage', 'user.locale', 'userLocale', 'i18nextLng', 'scale', 'api_host']);
  Object.keys(storage).forEach(key => {
    if (!keep.has(key)) storage.removeItem(key);
  });
  storage.setItem('networkName', network.name);
  storage.setItem('networkId', String(network.id));
}
